Ext.define('SA.view.AnimationFrameGenerator', {
    singleton: true,

    async * getGenerator() {
        while (true) {
            yield await new Promise(resolve => requestAnimationFrame(resolve));
        }
    }
});